// @TODO <HEALTH2019>
App.factory('authService', ['$rootScope', '$q', 'baseService', 'Config', function ($rootScope, $q, baseService, Config) {
// @TODO </HEALTH2019>
    function AuthService() {
        this.authenticate = function (email, password) {
            return baseService.logged(Config.AUTH_URL, $.param({
                grant_type: 'password',
                client_id: 'xilium',
                username: $rootScope.CONFIGURATOR.authPrefix + email,
                password: password
            })).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.logout = function () {
            return baseService.get(Config.API_URL + '/user/logout').then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.isConfirm = function (email, password) {
            return baseService.confirm(Config.API_URL + '/user/login', {
                email: email,
                password: password
            }).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.remind = function (data) {
            return baseService.confirm(Config.API_URL + '/user/remindPassword', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.register = function (data) {
            return baseService.register(Config.API_URL + '/user/register', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.completeRegister = function (token, data) {
            return baseService.register(Config.API_URL + '/user/confirmZochaRegistration/' + token, data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.confirmRegistration = function (token) {
            return baseService.confirm(Config.API_URL + '/user/confirmRegistration/' + token).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.confirmRegistrationChild = function (data) {
            return baseService.confirm(Config.API_URL + '/user/confirmRelativeRegistration', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.changePassword = function (data) {
            return baseService.confirm(Config.API_URL + '/user/changePasswordByToken', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.checkLoginExists = function (data) {
            return baseService.confirm(Config.API_URL + '/user/checkLoginExists', data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.loginByChangePasswordToken = function (token) {
            return baseService.confirm(Config.API_URL + '/user/loginByChangePasswordToken/' + token).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.zochaRegistrationDataByToken = function (token) {
            return baseService.confirm(Config.API_URL + '/user/zochaRegistrationDataByToken/' + token).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

        this.checkIdentifierForZochaRegistrationToken = function (criteria) {
            return baseService.register(Config.API_URL + '/user/checkIdentifierForZochaRegistrationToken/' + criteria.token, criteria.data).then(function (success) {
                return success;
            }, function (error) {
                return error;
            });
        };

    }
    return new AuthService();
}]);
